import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { createBaseRestConfig } from '../GroupSetsServerApiHelper';

export interface ICreateGroupSetRequestBody {
    groupSet: {
        name: string;
    };
}

export interface ICreateGroupSetResult extends IResult {
    groupSet: {
        id: string;
        name: string;
        groupCount: number;
    };
}

export async function createGroupSet(groupSetName: string): Promise<ICreateGroupSetResult> {
    const body: ICreateGroupSetRequestBody = {
        groupSet: {
            name: groupSetName
        }
    };
    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'POST',
        endpoint: `groupsets`,
        requestBody: body
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (reason) => {
        // map errors into IResult errors
        let responseError = reason.data?.error;
        if (responseError) {
            return {
                groupSet: undefined,
                errors: [responseError]
            };
        }
        return Promise.reject(reason);
    });
}